exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.col {\n  border: 1px solid #c0c0c0;\n}\n\ndiv.header-row div.col {\n  border: 2px solid black;\n  font-weight: bold;\n  margin-bottom: 3px;\n}\n\ndiv.value-row {\n\n}\n\ndiv.suspicion {\n  border: 1px solid #6666cc;\n  margin-top: 8px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/bdegroot/Projects/vgtropics-ph/src/app/zoonoses/zoonoses.component.css
// module id = ../../../../../src/app/zoonoses/zoonoses.component.css
// module chunks = main